import React, { Fragment } from 'react'

const RouteLoginForgotPasswordConfirmation = () => (
  <Fragment>
    <h6>Password reset email sent!</h6>
    <p>We've sent you an email with instructions to reset your password.</p>
  </Fragment>
)

export default RouteLoginForgotPasswordConfirmation



// WEBPACK FOOTER //
// ./src/routes/login/forgot-password/confirmation.js